import { useState } from 'react'
import { useMutation } from 'urql'
import { gql } from '../gql/gql'
import { Button } from './ui/button'
import { Label } from './ui/label'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select'
import { SUPPORTED_CURRENCIES } from '../lib/currencies'

const UPDATE_USER_MUTATION = gql(`
  mutation UpdateUserCurrency($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      preferredCurrency
    }
  }
`)

interface CurrencyOnboardingDialogProps {
  open: boolean
  name: string
}

export function CurrencyOnboardingDialog({ open, name }: CurrencyOnboardingDialogProps) {
  const [currency, setCurrency] = useState('USD')
  const [{ fetching }, updateUser] = useMutation(UPDATE_USER_MUTATION)

  const handleSave = async () => {
    await updateUser({ input: { name, preferredCurrency: currency } })
    // urql cache update will set preferredCurrency — parent will close this when data updates
  }

  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-xs [&>button]:hidden">
        <DialogHeader>
          <DialogTitle>What's your currency?</DialogTitle>
          <DialogDescription>
            We'll use this to display all your expenses correctly.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-1">
          <div className="space-y-1">
            <Label htmlFor="onboarding-currency">Currency</Label>
            <Select value={currency} onValueChange={setCurrency}>
              <SelectTrigger id="onboarding-currency">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {SUPPORTED_CURRENCIES.map(({ code, label }) => (
                  <SelectItem key={code} value={code}>{label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button className="w-full" onClick={handleSave} disabled={fetching}>
            {fetching ? 'Saving...' : 'Get started'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
